export const initLocale = (locale = {}) => ({
    ...(locale || {}),

    ko: locale?.ko ?? null,
    en: locale?.en ?? null,
});
